/**
 * Remembers the last response for each seeding destination page request, for this tab only,
 * so a destination reopens instantly from it while fresh data loads. Requests already in
 * flight are shared, so clicking a destination reuses the prefetch its hover started.
 * Logout and login reload the page, which clears it.
 */
import client from './client';

const responses = new Map();
const inflight = new Map();

export const USER_URL = '/auth/user/';
export const itemsUrl = (id) => `/seeding/destinations/${id}/items/`;
export const preferencesUrl = (id) => `/seeding/destinations/${id}/preferences/`;

export const getCached = (url) => responses.get(url);

export function fetchCached(url) {
  if (!inflight.has(url)) {
    inflight.set(url, client.get(url)
      .then((response) => {
        responses.set(url, response);
        return response;
      })
      .finally(() => inflight.delete(url)));
  }
  return inflight.get(url);
}

export function prefetchDestination(id) {
  [USER_URL, itemsUrl(id), preferencesUrl(id)].forEach((url) => {
    if (!responses.has(url)) fetchCached(url).catch(() => {});
  });
}

export function forgetDestination(id) {
  responses.delete(itemsUrl(id));
  responses.delete(preferencesUrl(id));
}
